import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";

import { isDecimalNumber, isWholeNumber } from "../../utils/helpers";

export const Input = ({
  name,
  value = "",
  label = "",
  type = "text",
  onChange,
  onFocus,
  onBlur,
  required = false,
  hasError = false,
  size = "small",
  errorText = "",
  helperText = "",
  ...props
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const handleFocus = (e) => {
    setError("");

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    if (!value && required) {
      setError(t("error_input_required"));
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;

    if (type === "number" && !!value && !isDecimalNumber(value)) {
      return;
    }

    if (type === "wholeNumber" && !!value && !isWholeNumber(value)) {
      return;
    }

    if (name === "minutes" && +value > 59) {
      return;
    }

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      margin="normal"
      type="text"
      size={size}
      name={name}
      value={value}
      label={label}
      error={hasError || !!error}
      helperText={error || errorText || helperText}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      slotProps={{
        htmlInput: {
          inputMode: type !== "text" ? "numeric" : "text",
        },
      }}
      {...props}
    />
  );
};
